<script setup lang="ts">
import {IconClose} from '@hantera/design-system'

const props = defineProps<{
  error: {
    id: number
    code?: string
    title?: string
    message?: string
  }
}>()

const emit = defineEmits<{
  (event: 'close'): void
}>()

</script>

<template>
  <div class="toast-error">
    <div class="title" v-if="error.title">
      {{error.title}}
    </div>
    <div class="message">
      {{error.message}}
    </div>
    <div class="code" v-if="error.code">
      Code: {{error.code}}
    </div>
    <div class="close" @click="emit('close')">
      <IconClose />
    </div>
  </div>
</template>

<style scoped>

.toast-error {
  border: 1px solid var(--color-error);
  background-color: var(--color-error-100);
  padding: 10px;
  border-radius: 5px;
  display: grid;
  gap: 5px;
  grid-template-columns: auto 30px;
}

.title {
  grid-column: 1 / 2;
  font-weight: bold;
}

.message, .code {
  grid-column: 1 / 2;
}

.close {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  text-align: right;
  cursor: pointer;
  color: #000;
  opacity: .5;
  transition: opacity 200ms;
}

.close svg {
  width: 14px;
}

.close:hover {
  opacity: 1;
}

</style>